import { validateOptionFields } from "../utils/validate-option-fields.js";
//#region ../src/ar/ar-crash-isolation.ts
/**
* AR crash isolation flags — diagnostic gates for XR session negotiation.
*
* Moved out of the recorder settings catalog (2026-07-11 G-1 move,
* `2026-07-11-1445-recording-options-altitude-move-plan.md`): the framework itself
* consumes these flags in `webxr-session.ts` (session feature requests, frame
* loop) and on `enable-gps-ar.ts`'s public param, so the type + defaults +
* validator live framework-side. The recorder embeds the group in its own
* `RecordingOptions` catalog and re-exports the type.
*/
/** Default AR-crash-isolation flags (all features enabled). */
const DEFAULT_AR_CRASH_ISOLATION = {
	enableDomOverlay: true,
	enableCameraAccess: true,
	enableDepthSensingFeature: true,
	enableCss3dRenderer: true,
	enableCameraTextureAcquisition: true,
	applyChromiumProjectionLayerWorkaround: true
};
/**
* Validate and normalize AR crash isolation flags.
*
* Boolean-or-default per field (quality-review C-1): persisted/external values
* are untrusted, so anything that is not a real boolean falls back to the
* default. The container itself is as untrusted as its fields (persisted blobs
* may lack the key entirely or hold `null`), so a nullish container yields the
* full defaults instead of throwing.
*/
function validateArCrashIsolationOptions(rawOptions) {
	return validateOptionFields(rawOptions, DEFAULT_AR_CRASH_ISOLATION, {
		enableDomOverlay: { kind: "bool" },
		enableCameraAccess: { kind: "bool" },
		enableDepthSensingFeature: { kind: "bool" },
		enableCss3dRenderer: { kind: "bool" },
		enableCameraTextureAcquisition: { kind: "bool" },
		applyChromiumProjectionLayerWorkaround: { kind: "bool" }
	});
}
//#endregion
export { DEFAULT_AR_CRASH_ISOLATION, validateArCrashIsolationOptions };
